import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';

import '@fontsource-variable/inter';
import './styles/index.css';
import App from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    // offlineFirst: без сети показываем то, что уже загружено, а не вечный спиннер.
    queries: { refetchOnWindowFocus: true, retry: 1, staleTime: 15_000, networkMode: 'offlineFirst' },
    mutations: { networkMode: 'offlineFirst' },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster
          position="top-center"
          containerStyle={{ top: 'max(12px, env(safe-area-inset-top))' }}
          toastOptions={{ duration: 3500, style: { fontSize: '14px', borderRadius: '12px' } }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
